import { MantineThemeOverride } from '@mantine/core';

export type CardTheme = NonNullable<MantineThemeOverride['components']>['Card'];

export const Card: CardTheme = {
  // todo: define
};
